export default "__VITE_ASSET__Cj5xz6k3__"